import { createFileRoute } from '@tanstack/react-router';
import { LabelSettings } from '@/features/projects/settings/label-settings';

export const Route = createFileRoute('/_app/p/$projectKey/settings/labels')({
  component: RouteComponent,
});

function RouteComponent() {
  const { projectKey } = Route.useParams();
  return <LabelSettings projectKey={projectKey} />;
}
